import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';

export const SpotlightModal: React.FC = () => {
  const { spotlightNotification, showSpotlight, setShowSpotlight, markAsRead } = useNotifications();
  
  if (!showSpotlight || !spotlightNotification) return null;
  
  const handleClose = () => {
    setShowSpotlight(false);
    markAsRead(spotlightNotification.id);
  };
  
  const handleAction = () => {
    if (spotlightNotification.data.action_url) {
      window.location.href = spotlightNotification.data.action_url;
    }
    handleClose();
  };
  
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-2">
          {spotlightNotification.data.title || 'Notification'}
        </h2>
        <p className="mb-4">{spotlightNotification.data.message}</p>
        <div className="flex justify-end space-x-2">
          <button 
            onClick={handleClose}
            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded"
          >
            Close
          </button>
          {spotlightNotification.data.action_url && (
            <button 
              onClick={handleAction}
              className="px-4 py-2 bg-blue-500 text-white rounded"
            >
              View
            </button>
          )}
        </div>
      </div>
    </div>
  );
}; 